if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        this.emitProductModalActive(false);
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.emitProductModalActive();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
          const elementWrapper = element.closest('[data-product-media-thumbnail]') || null;
          if (elementWrapper) {
            elementWrapper.classList.remove('active');
          }
        });

        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaWrapper = activeMedia.closest('[data-product-media-thumbnail]');
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMediaWrapper.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      emitProductModalActive(pause = true) {
        publish(PUB_SUB_EVENTS.toggleMediaGallery, {
          data: {
            pause,
          },
        });
      }
    }
  );
}
